export default "__VITE_ASSET__CKUsjI$d__"